import React from 'react';
import { Suggestion } from '@components/common/Suggestion';
import { useMediaQueryContext } from '@fourthwall/components';
import launchGuide from '../../assets/launch-guide.png';
import * as S from './LaunchStrategyRecommendation.styled';
export const LaunchStrategyRecommendation = ({ title, description, buttonLabel = 'Read the guide', primaryImageSrc, secondaryImageSrc, imagesDescription, onClick, onDismiss, }) => {
    const media = useMediaQueryContext();
    return (React.createElement(Suggestion, { analytics: "readTheGuideUltimateLaunchGuide", title: title, description: description, buttonLabel: buttonLabel, sideContent: media.tablet ? (React.createElement(S.ImagesContent, null,
            React.createElement(S.PrimaryImage, { src: primaryImageSrc }),
            React.createElement(S.SecondaryImage, { src: secondaryImageSrc }),
            React.createElement(S.ImagesDescription, null, imagesDescription))) : undefined, imageUrl: launchGuide, onButtonClick: onClick, onDismiss: onDismiss }));
};
